/* --------------------------------------------------------------------------------------
   errorMessage.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const errorMessageComponent = {
  template: require('./errorMessage.html'),
  controllerAs: 'vm',
  bindings: {
    error: '=',
    onClose: '&'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/errorMessage.component.js